import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=2a5776f2&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=2a5776f2&prod&lang=less&scoped=true&"
import style1 from "./chat.vue?vue&type=style&index=1&id=2a5776f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5776f2",
  null
  
)

export default component.exports